/**
 * What one indexed row *is*, so a count can say so. The tiers count different things — a batch at a stage, a
 * leg of an EPC delta — and rendered as "N rows" both read as one population measured twice. Naming the unit
 * is what makes the two counts non-comparable on sight, which they are.
 *
 * Both forms are stored rather than derived, because English plurals are not a suffix rule.
 */
export interface RowUnit {
  one: string;
  many: string;
}

/** A count with its unit attached: `1 batch`, `412 batches`. Localised, as every count on these panels is. */
export const countOf = (count: number, unit: RowUnit): string =>
  `${count.toLocaleString()} ${count === 1 ? unit.one : unit.many}`;
